// import React from 'react'
// import { Grid, useMediaQuery, Theme } from '@material-ui/core'
// import { useTheme } from 'styled-components'
// import { useChartData } from './hooks/useChartData'

// import { useTalentContext } from '../Talents/context'

// import { TeamDynamicChart } from './components/TeamDynamicChart'
// import TeamGaugeChart from './components/TeamGuageChart/TeamGuageChart'

// const TeamChart = ({
// 	groupSelectionMapping
// }: {
// 	groupSelectionMapping: Record<string, boolean>
// }) => {
// 	const theme = useTheme()
// 	const lgDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'))
// 	const { chartData, chartSkills } = useChartData()
// 	const [{ selectedTalent }] = useTalentContext()

// 	const matchedSkillId = '67dbf4d42c98d18c9d68381f'

// 	const hasMatchingSkillWithNull = selectedTalent?.score?.skills?.some(
// 		skill => skill.skillId === matchedSkillId && !skill.skill
// 	)
// 	console.log('SkillId', hasMatchingSkillWithNull)
// 	if (hasMatchingSkillWithNull) {
// 		return (
// 			<Grid
// 				container
// 				justifyContent="center"
// 				alignItems="center"
// 				item
// 				xs={12}
// 				style={{ height: lgDown ? 350 : 450 }}
// 			>
// 				<TeamGaugeChart
// 					data={chartData}
// 					skills={chartSkills.filter(({ id }) => groupSelectionMapping[id])}
// 				/>
// 			</Grid>
// 		)
// 	} else {
// 		// Show only TeamDynamicChart
// 		return (
// 			<Grid item xs={12} style={{ height: lgDown ? 350 : 450 }}>
// 				<TeamDynamicChart
// 					data={chartData}
// 					skills={chartSkills.filter(({ id }) => groupSelectionMapping[id])}
// 				/>
// 			</Grid>
// 		)
// 	}
// }

// export default TeamChart

import React from 'react'
import { Grid, useMediaQuery, Theme } from '@material-ui/core'
import { useTheme } from 'styled-components'
import { useChartData } from './hooks/useChartData'

import { useTalentContext } from '../Talents/context'

import { TeamDynamicChart } from './components/TeamDynamicChart'
import TeamGaugeChart from './components/TeamGuageChart/TeamGuageChart'

const TeamChart = ({
	groupSelectionMapping
}: {
	groupSelectionMapping: Record<string, boolean>
}) => {
	const theme = useTheme()
	const lgDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'))
	const { chartData, chartSkills } = useChartData()
	const [{ selectedTalent }] = useTalentContext()

	const matchedSkillId = '67dbf4d42c98d18c9d68381f'

	const hasMatchingSkill = selectedTalent?.score?.skills?.some(
		skill => skill.skillId === matchedSkillId
	)

	// console.log('SkillId matched:', hasMatchingSkill)

	if (hasMatchingSkill) {
		return (
			<Grid
				container
				justifyContent="center"
				alignItems="center"
				item
				xs={12}
				style={{ height: lgDown ? 350 : 450 }}
			>
				{/* <TeamGaugeChart
					data={chartData}
					skills={chartSkills.filter(({ id }) => groupSelectionMapping[id])}
				/> */}
				<TeamGaugeChart data={chartData} skills={chartSkills} />
			</Grid>
		)
	} else {
		return (
			<Grid item xs={12} style={{ height: lgDown ? 350 : 450 }}>
				<TeamDynamicChart
					data={chartData}
					skills={chartSkills.filter(({ id }) => groupSelectionMapping[id])}
				/>
			</Grid>
		)
	}
}

export default TeamChart
